var map = {
	"./banner/large/en1.jpg": 5996,
	"./banner/large/en2.jpg": 9939,
	"./banner/large/en3.jpg": 6279,
	"./banner/large/en4.jpg": 723,
	"./banner/large/en5.jpg": 8236,
	"./banner/large/zh1.jpg": 2744,
	"./banner/large/zh2.jpg": 3647,
	"./banner/large/zh3.jpg": 1768,
	"./banner/large/zh4.jpg": 9882,
	"./banner/large/zh5.jpg": 9246,
	"./banner/small/en1.jpg": 6446,
	"./banner/small/en2.jpg": 5295,
	"./banner/small/en3.jpg": 2264,
	"./banner/small/en4.jpg": 8754,
	"./banner/small/en5.jpg": 6313,
	"./banner/small/zh1.jpg": 9257,
	"./banner/small/zh2.jpg": 586,
	"./banner/small/zh3.jpg": 187,
	"./banner/small/zh4.jpg": 149,
	"./banner/small/zh5.jpg": 8618,
	"./buy/alibaba.jpg": 5053,
	"./buy/jingdong.jpg": 8099,
	"./buy/pinduoduo.jpg": 8874,
	"./buy/tianmao.jpg": 3757,
	"./common/background.jpg": 2016,
	"./common/certificate.jpg": 721,
	"./company/authorization.jpg": 599,
	"./company/companyEnvironment/1.jpg": 6377,
	"./company/companyEnvironment/2.jpg": 9370,
	"./company/companyEnvironment/3.jpg": 6693,
	"./company/companyEnvironment/4.jpg": 5684,
	"./company/companyEnvironment/5.jpg": 2441,
	"./company/companyEnvironment/6.jpg": 1403,
	"./company/enterpriseHonor/1.jpg": 9243,
	"./company/enterpriseHonor/10.jpg": 1304,
	"./company/enterpriseHonor/11.jpg": 6636,
	"./company/enterpriseHonor/12.jpg": 7560,
	"./company/enterpriseHonor/2.jpg": 584,
	"./company/enterpriseHonor/3.jpg": 5617,
	"./company/enterpriseHonor/4.jpg": 5810,
	"./company/enterpriseHonor/5.jpg": 5037,
	"./company/enterpriseHonor/6.jpg": 1974,
	"./company/enterpriseHonor/7.jpg": 6548,
	"./company/enterpriseHonor/8.jpg": 6019,
	"./company/enterpriseHonor/9.jpg": 218,
	"./company/hzmanqini_alibaba.jpg": 1314,
	"./company/jiuling.jpg": 7521,
	"./company/jiuling_alibaba.jpg": 3521,
	"./company/jiulinghistory.jpg": 6298,
	"./products/FY1001.jpg": 1549,
	"./products/FY1002.jpg": 6290,
	"./products/FY1005.jpg": 9604,
	"./products/FY1006.jpg": 5327,
	"./products/FY1009.jpg": 7211,
	"./products/FY1010.jpg": 9167,
	"./products/FY1011.jpg": 9481,
	"./products/FY1012.jpg": 5298,
	"./products/FY1015.jpg": 7902,
	"./products/FY1016.jpg": 7925,
	"./products/FY1017.jpg": 9026,
	"./products/FY2001.jpg": 9602,
	"./products/FY2005.jpg": 2707,
	"./products/FY2006.jpg": 363,
	"./products/FY2007.jpg": 9691,
	"./products/FY2009.jpg": 4111,
	"./products/FY2010.jpg": 8725,
	"./products/FY3001.jpg": 7625,
	"./products/JL0198.jpg": 7193,
	"./products/JL1233.jpg": 2528,
	"./products/JL1234.jpg": 7556,
	"./products/JL1700.jpg": 7454,
	"./products/JL1701.jpg": 394,
	"./products/JL1800.jpg": 1668,
	"./products/JL1801.jpg": 7620,
	"./products/JL1822.jpg": 7431,
	"./products/JL1828.jpg": 6744,
	"./products/JL1830.jpg": 1788,
	"./products/JL1832.jpg": 9715,
	"./products/JL1833.jpg": 8801,
	"./products/JL1839.jpg": 1156,
	"./products/JL1850.jpg": 8157,
	"./products/JL1851.jpg": 8342,
	"./products/JL1868.jpg": 2772,
	"./products/JL1901.jpg": 5636,
	"./products/JL311.jpg": 6288,
	"./products/JL312.jpg": 6728,
	"./products/JL51.jpg": 249,
	"./products/JL6151.jpg": 9495,
	"./products/JL6158.jpg": 2167,
	"./products/JL8003.jpg": 5172,
	"./products/JL8004.jpg": 2144,
	"./products/JL8008.jpg": 4484,
	"./products/JL8109.jpg": 8190,
	"./products/JL8112.jpg": 3740,
	"./products/JL8116.jpg": 5934,
	"./products/JL8120.jpg": 9609,
	"./products/JL8121.jpg": 3575,
	"./products/JL83.jpg": 2128,
	"./products/JL8810.jpg": 4607,
	"./products/N1001.jpg": 6704,
	"./products/N1002.jpg": 559,
	"./products/N2188.jpg": 4615,
	"./products/N28.jpg": 9578,
	"./products/N2800.jpg": 9376,
	"./products/N2801.jpg": 5695,
	"./products/N2801_14B16B.jpg": 4810,
	"./products/N2801_sketch.jpg": 69,
	"./products/N2802.jpg": 7919,
	"./products/N2802_charcoal_sketch.jpg": 1818,
	"./products/N2805.jpg": 9147,
	"./products/N2806.jpg": 7093,
	"./products/N2806_ironbox.jpg": 3893,
	"./products/N2810.jpg": 2652,
	"./products/N2820.jpg": 1233,
	"./products/N2828.jpg": 2145,
	"./products/N2829.jpg": 7226,
	"./products/N2830.jpg": 4129,
	"./products/N2831.jpg": 3904,
	"./products/N283112.jpg": 741,
	"./products/N2834.jpg": 8745,
	"./products/N2900.jpg": 6934,
	"./products/N8109.jpg": 9994,
	"./products/N8128.jpg": 460,
	"./products/N8129.jpg": 6853,
	"./products/N8133.jpg": 7153,
	"./products/N8135.jpg": 3107,
	"./products/N8136_29.jpg": 9746,
	"./products/N8136_30.jpg": 7495,
	"./products/N8137.jpg": 7916,
	"./products/N8201.jpg": 7978,
	"./products/N8208.jpg": 4854,
	"./products/N8209.jpg": 6790,
	"./products/N8210.jpg": 5991,
	"./products/N8211.jpg": 8864,
	"./products/N8213.jpg": 3377,
	"./products/N8215.jpg": 9812,
	"./products/N8302.jpg": 7497,
	"./products/N8308.jpg": 3932,
	"./products/N8508.jpg": 8944,
	"./products/N8511.jpg": 8427,
	"./products/N8515.jpg": 2741,
	"./products/N8520.jpg": 6420,
	"./products/N8521.jpg": 6801,
	"./products/N8522.jpg": 8068,
	"./products/N8525.jpg": 4937,
	"./products/N8526.jpg": 4057,
	"./products/N8530.jpg": 3815,
	"./products/N8535.jpg": 9067,
	"./products/N8608.jpg": 3069,
	"./products/catalog/charcoal_pencil.jpg": 2887,
	"./products/catalog/color_pencil.jpg": 4885,
	"./products/catalog/eraser.jpg": 5795,
	"./products/catalog/eraser1.jpg": 7890,
	"./products/catalog/other_tools.jpg": 5355,
	"./products/catalog/school_office_pencil.jpg": 6976,
	"./products/catalog/sketch_pencil.jpg": 7893,
	"./video/NYONI.jpg": 3352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;